import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import style from './CatalogPreviewModal.module.scss';
import Modal from 'react-bootstrap/Modal';
import CatalogPreview from './CatalogPreview';
import useCatalogItemListener from '../../hook/UseCatalogItemListener';
import {useTranslation} from 'react-i18next';

const CatalogPreviewModal = (props) => {

  const [open, setOpen] = useState(false);
  const {catalog} = useCatalogItemListener();
  const {t} = useTranslation(['catalog']);

  const onModalClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (catalog) {
      setOpen(true);
    }
  }, [catalog]);

  return (
    <Modal
      show={open}
      onHide={onModalClose}
      className="modal-catalog-preview fade"
      dialogClassName={style.CatalogPreviewModal}
      size={'lg'}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t('catalog.preview.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CatalogPreview catalog={catalog}/>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={onModalClose} className="btn btn-default btn-wide btn-xl" data-dismiss="modal" aria-label="Close">{t('close')}</button>
      </Modal.Footer>
    </Modal>
  )

};

export default CatalogPreviewModal;
